import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getThemeProp } from 'theme';

const Icon = styled.i`
  align-items: center;
  color: ${getThemeProp('colors.moodyBlue2')};
  display: flex;
  margin-right: 12px;
`;

const Button = styled.button`
  align-items: center;
  display: flex;
  font-size: 12px;
  height: 28px;
  padding-left: 16px;
  width: 100%;

  &:hover {
    background-color: ${getThemeProp('colors.havelockBlue')};
    color: ${getThemeProp('colors.white')};
    cursor: pointer;

    i {
      color: ${getThemeProp('colors.white')};
    }
  }
`;

const ActionButton = ({ label, iconName, onClick, dataTest }) => (
  <Button data-test={dataTest} onClick={onClick}>
    <Icon className={iconName} />
    <div>{label}</div>
  </Button>
);

ActionButton.propTypes = {
  dataTest: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ActionButton;
